<template lang="html">
  <div>
    <div>
      <div>
        <div>
          <current-form :operation=operation></current-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CurrentForm from './form'
  export default {
    name: 'duzenle',
    data() {
      return {
        operation: 'update'
      }
    },
    components: {
      'current-form': CurrentForm
    }
  }
</script>

<style>
</style>